import styled from "styled-components";
import {Card} from "antd";

export const CommunicationPreferencesCardContainer = styled(Card)`
    margin-top: 20px;
    margin-bottom: 20px;
    height: 100%;
`;

export const HeaderText = styled.span`
    margin-left: 10px;
`;
